import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { useNavigate } from "react-router-dom";
import ItemsDetails from "./ItemsDetails";
import ItemsDrawings from "./ItemsDrawings";
import ItemsAssets from "./ItemsAssets";
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
      width: "100%",
      background: "transparant",
    },
    button: {
      margin: theme.spacing(3),
      fontFamily: "Calibri",
      fontWeight: "bold",
      color: "White",
      fontSize: "15px",
      width: "95%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    text: {
      marginTop: theme.spacing(7),
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      fontSize: "30px",
      fontFamily: "Calibri",
      fontWeight: "bold",
      marginLeft: 35,
    },
    Line: {
      border: "1px solid #3F51B5",
      width: "15%",
      marginLeft: 35,
    },
  })
);

function getSteps() {
  return ["Item Details", "Drawings", "Assets"];
}
function getStepsdrawing() {
  return ["Item Details", "Assets"];
}
function getStepsassets() {
  return ["Item Details", "Drawings"];
}
function getSteponly() {
  return ["Item Details"];
}
export default function RegisterItems() {
  const Navigate = useNavigate();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  
  const Permissions = useSelector((state) => state.user.userPermissions);
  const adddrawing = Permissions.find((o) => o.codename === "add_drawing");
  const addassets = Permissions.find((o) => o.codename === "add_asset");

  const steps = getSteps();
  const stepsdrawing = getStepsdrawing();
  const stepsassets = getStepsassets();
  const stepsonly = getSteponly();


  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <ItemsDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 1:
        return (
          <ItemsDrawings
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 2:
        return (
          <ItemsAssets
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      default:
        Navigate("/dashboard/management/items")
    }
  };
  const getStepContentdrawing = (step: number) => {
    switch (step) {
      case 0:
        return (
          <ItemsDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
     
      case 1:
        return (
          <ItemsAssets
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      default:
        Navigate("/dashboard/management/items")
    }
  };
  const getStepContentassets = (step: number) => {
    switch (step) {
      case 0:
        return (
          <ItemsDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 1:
        return (
          <ItemsDrawings
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
   
      default:
        Navigate("/dashboard/management/items")
    }
  };
  const getStepContentonly = (step: number) => {
    switch (step) {
      case 0:
        return (
          <ItemsDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
   
      default:
        Navigate("/dashboard/management/items")
    }
  };

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  return (
    <>
      <div className="min-h-full flex items-center container my-5 ml-7">
        <div className=" w-full ">
          <div>
            <h2 className="text-left font-Montserrat text-xl font-bold text-black">
              Register New Item
            </h2>
            <div className="border-b-2 border-blue-200 w-24"></div>
          </div>
        </div>
      </div>

      <div className="max-w-full px-4 sm:px-6 lg:px-8">
        <div className={classes.root}>
          {/* <Stepper activeStep={activeStep}> */}

          {/* {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: { optional?: React.ReactNode } = {};
            if (isStepOptional(index)) {
              // labelProps.optional = (
              //   <Typography variant="caption">Optional</Typography>
              // );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })} */}
          
    {!addassets ===undefined ||  addassets?.codename ===
        "add_asset" ? (
          !adddrawing ===undefined ||  adddrawing?.codename ===
        "add_drawing" ? (
          <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: { optional?: React.ReactNode } = {};
            if (isStepOptional(index)) {
              // labelProps.optional = (
              //   <Typography variant="caption">Optional</Typography>
              // );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
            </Stepper>
        ): ( 
            <Stepper activeStep={activeStep}>
            {stepsdrawing.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: { optional?: React.ReactNode } = {};
            if (isStepOptional(index)) {
              // labelProps.optional = (
              //   <Typography variant="caption">Optional</Typography>
              // );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
            </Stepper>
        )
          
          


        ): !adddrawing ===undefined ||  adddrawing?.codename ===
          "add_drawing" ? (
            <Stepper activeStep={activeStep}>
            {stepsassets.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: { optional?: React.ReactNode } = {};
              if (isStepOptional(index)) {
                // labelProps.optional = (
                //   <Typography variant="caption">Optional</Typography>
                // );
              }
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
             </Stepper>
          ): (

            <Stepper activeStep={activeStep}>
          {stepsonly.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: { optional?: React.ReactNode } = {};
            if (isStepOptional(index)) {
              // labelProps.optional = (
              //   <Typography variant="caption">Optional</Typography>
              // );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
         </Stepper>
          )}


          {/* </Stepper> */}
          <Typography className={classes.instructions}>
          {!addassets ===undefined ||  addassets?.codename ===
        "add_asset" ? (
          !adddrawing ===undefined ||  adddrawing?.codename ===
        "add_drawing" ? (
          getStepContent(activeStep)
        ): (getStepContentdrawing(activeStep))
          
          


        ): !adddrawing ===undefined ||  adddrawing?.codename ===
          "add_drawing" ? (
            getStepContentassets(activeStep)
          ): (getStepContentonly(activeStep))}

            {/* {getStepContent(activeStep)} */}
          </Typography>
        </div>
      </div>
    </>
  );
}
